export default __webpack_public_path__ + "static/media/sofa.14feb604.webp";